import { useEffect, useState } from "react";

const calc = (deadline) => {
  const ms = Math.max(0, new Date(deadline).getTime() - Date.now());
  return { d: Math.floor(ms / 86400000), h: Math.floor(ms / 3600000) % 24, m: Math.floor(ms / 60000) % 60, s: Math.floor(ms / 1000) % 60, done: ms === 0 };
};

export const Countdown = ({ deadline, compact, testId = "countdown" }) => {
  const [t, setT] = useState(calc(deadline));
  useEffect(() => {
    const i = setInterval(() => setT(calc(deadline)), 1000);
    return () => clearInterval(i);
  }, [deadline]);
  if (t.done) return <span data-testid={testId} className="font-mono-tech text-xs uppercase text-red-400">Encerrado</span>;
  const parts = [["d", t.d], ["h", t.h], ["m", t.m], ["s", t.s]];
  if (compact) {
    return <span data-testid={testId} className="font-mono-tech text-xs text-cyan-300">{t.d}d {t.h}h {t.m}m</span>;
  }
  return (
    <div data-testid={testId} className="flex gap-2">
      {parts.map(([k, v]) => (
        <div key={k} className="glass min-w-[58px] rounded-md px-2 py-2 text-center">
          <div className="font-display text-3xl font-bold tabular-nums text-white">{String(v).padStart(2, "0")}</div>
          <div className="font-mono-tech text-[10px] uppercase text-slate-500">{k}</div>
        </div>
      ))}
    </div>
  );
};
